import graphqlClient from '../../api/axios_interceptor';
import { FormDataRestClient } from '../../api/rest_interceptor';
import { GRAPHQL_API } from '../../api/graphql/endpoint';
import { getFormData } from './functions';
import {
    FETCH_PAYMENTS,
    ADD_PAYMENT,
    UPDATE_PAYMENT,
    DELETE_PAYMENTS,
    ASSIGN_PAYMENT,
    FETCH_FINANCIALS_GRAPH,
    REALLOCATE_PAYMENT
} from '../actions/actionTypes';
import { updateActionErrors } from './updateErrors';

import {
    getPaymentsQuery,
    addPaymentMutation,
    updatePaymentMutation,
    assignPaymentMutation,
    getFinancialsGraphQuery,
    reallocatePaymentMutation,
    deletePaymentsMutation
} from "../../api/graphql/queries/payments";
import {convertDateToUserLocalDate} from "../../utils/general"


export const parsePayment = (payment) => ({
    paymentId: payment.id,
    tenant: payment.tenantDetails,
    tenantId: payment.tenantDetails? payment.tenantDetails.tenantId : "",
    amount: payment.amount,
    bankTransactionId: payment.bankTransactionId,
    description: payment.description,
    createdBy: payment.createdBy ? payment.createdBy : "",
    teamMemberId: payment.recordedBy ? payment.recordedBy.id : "",
    created: convertDateToUserLocalDate(payment.createdTs),
    paymentDate: payment.paymentDate,
    lastUpdated: payment.lastUpdated,
    type: payment.paymentType,
    status: payment.status,
    totalInvoiced: payment.totalInvoiced,
    creditNote: payment.creditNote,
    message: payment.message ? payment.message.id : "",
    fileName: payment.upload? payment.upload.file : "",
    fileId: payment.upload? payment.upload.id : "",
});

export const fetchPaymentsMiddleware = async (action) => {
    try {
        let payments = {};
        await graphqlClient({
            data: {
                query: getPaymentsQuery(action.payload)
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);

            } else {
                payments = queryResult.data.data.payments.payments.map(parsePayment);
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        payments
                    },
                    offset: queryResult.data.data.payments.next,
                    summary: queryResult.data.data.payments.summary
                });
            }
        });

    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}


export const fetchFinancialsGraphMiddleware = async (action) => {
    try{
        let graphData = [];
        await graphqlClient({
            data: {
                query: getFinancialsGraphQuery(action.payload)
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);

            } else {
                graphData = queryResult.data.data.financialsGraph;
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        graphData
                    }
                })
            }
        })
    } catch(error){
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}



const addPaymentMiddleware = async (action) => {
    try {
        const payload = action.payload;
        let query = addPaymentMutation(
            payload.tenantId, payload.amount, payload.paymentType,
            payload.description, payload.creditNote, payload.status,
            payload.paymentDate, payload.bankTransactionId, payload.sendReceipt
        );
        const formData = getFormData(query, action.payload.fileUpload);
        await FormDataRestClient.post(GRAPHQL_API, formData).then(
            (queryResult) => {
                if (queryResult.data.errors) {
                    action = updateActionErrors(action, queryResult.data.errors);

                } else if (queryResult.data.data.addPayment.error) {
                    action = updateActionErrors(action, queryResult.data.data.addPayment.error.message);
                }
                else {
                    action = ({
                        ...action,
                        payload: {
                            ...payload,
                            payment: parsePayment(queryResult.data.data.addPayment.payment)
                        }
                    });
                }
        });
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const assignPaymentMiddleware = async (action) => {
    try {
        const payload = action.payload;
        let query = assignPaymentMutation(payload.tenantId, payload.paymentId);
        await graphqlClient({
            data: {
                query: query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.assignPaymentToTenant.error) {
                action = updateActionErrors(action, queryResult.data.data.assignPaymentToTenant.error.message);
            }
            else {
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        payment: parsePayment(queryResult.data.data.assignPaymentToTenant.payment)
                    }
                });
            }
        })
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const reallocatePaymentMiddleware = async (action) => {
    try {
        const payload = action.payload;
        let query = reallocatePaymentMutation(payload.tenantId, payload.paymentId);
        await graphqlClient({
            data: {
                query: query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.reallocatePaymentToAnotherTenant.error) {
                action = updateActionErrors(action, queryResult.data.data.reallocatePaymentToAnotherTenant.error.message);
            }
            else {
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        payment: parsePayment(queryResult.data.data.reallocatePaymentToAnotherTenant.payment)
                    }
                });
            }
        })
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const updatePaymentMiddleware = async (action) => {
    try {
        const payload = action.payload;
        let query = updatePaymentMutation(payload.paymentId, {
            amount: payload.amount,
            paymentType: payload.paymentType,
            description: payload.description,
            tenantId: payload.tenantId,
            status: payload.status,
            paymentDate: payload.paymentDate,
            updateFile: payload.updateFile,
            bankTransactionId: payload.bankTransactionId,
            sendReceipt: payload.sendReceipt
        });

        const formData = getFormData(query, action.payload.fileUpload);
        await FormDataRestClient.post(
            GRAPHQL_API, formData
        ).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);

            } else if (queryResult.data.data.updatePayment.error) {
                action = updateActionErrors(action, queryResult.data.data.updatePayment.error.message);
            }
            else {
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        payment: parsePayment(queryResult.data.data.updatePayment.payment)
                    }
                });
            }
        })
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const deletePaymentsMiddleware = async action => {
    try {
        let payload = action.payload;
        await graphqlClient({
            data: {
                query: deletePaymentsMutation(payload.paymentIds)
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.deletePayment.error) {
                action = updateActionErrors(action, queryResult.data.data.deletePayment.error.message);
            }
            else {
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        success: queryResult.data.data.deletePayment.success
                    }
                });
            }
        })
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}


export const paymentsMiddleware = storeAPI => next => async action => {
    switch (action.type) {
        case FETCH_PAYMENTS:
            action = await fetchPaymentsMiddleware(action);
            break;
        case FETCH_FINANCIALS_GRAPH:
            action = await fetchFinancialsGraphMiddleware(action);
            break;
        case ADD_PAYMENT:
            action = await addPaymentMiddleware(action);
            break;
        case UPDATE_PAYMENT:
            action = await updatePaymentMiddleware(action);
            break;
        case DELETE_PAYMENTS:
            action = await deletePaymentsMiddleware(action);
            break;
        case ASSIGN_PAYMENT:
            action = await assignPaymentMiddleware(action);
            break;
        case REALLOCATE_PAYMENT:
            action = await reallocatePaymentMiddleware(action);
            break;
    }
    return next(action);
}
